module.exports = __webpack_public_path__ + "img/a67e585.svg";